import React from "react";
import "./Product.css";
import img1 from "../assets/abtpro-img1.png";
import img2 from "../assets/abtpro-img2.png";
import img3 from "../assets/abtpro-img3.png";
import { Link } from "react-router-dom";
import Footer from "./Footer";

function Products() {
  const products = [
    {
      img: img1,
      title: "Commercial vehicles",
      desc: "Robust, lightweight castings for enhanced durability and efficiency.",
      link: "/commercial",
    },
    {
      img: img2,
      title: "Passenger vehicles",
      desc: "High-performance components for next-generation mobility.",
      link: "/passenger",
    },
    {
      img: img3,
      title: "Two wheelers",
      desc: "Compact, precision-engineered castings for speed and reliability",
      link: "/twowheelers",
    },
  ];

  return (
    <section id="products">
      <section className="prod-section">
        <div className="pro-light-wrapper">
          {/* LEFT CONTENT */}
          <div className="prod-light-text">
            <h3>
              Aluminium Die Casting Solutions
              <br />
              Engineered for Excellence
            </h3>

            <p>At SCL, we are a trusted partner to global automotive and industrial leaders, offering precision-engineered aluminium pressure die castings that combine lightweight design with exceptional durability and performance. With decades of expertise in Pressure (PDC), gravity (GDC) die casting, SCL delivers innovative, reliable, and sustainable solutions for mobility across segments — from heavy commercial vehicles to passenger cars.</p>
            <p style={{ margin: "10px 0 0 0" }}>SCL machined products are engineered for dimensional accuracy, structural integrity and long service life — enabling light weighting, improved efficiency and simplified assembly for OEMs worldwide.</p>
          </div>

          {/* RIGHT IMAGE / PLACEHOLDER */}
          <div className="lightweighting-image">
            
          </div>
        </div>


        <h2 className="prod-title">Products</h2>
        <div className="title-underline"></div>
        <p className="prod-subtext">
          We specialize in delivering end-to-end solutions—from design collaboration to production of fully machined
        </p>

        <div className="prod-container">
          {products.map((item, index) => (
            <div className="prod-card" key={index}>
              <div className="prod-img-wrap">
                <img src={item.img} alt={item.title} className="prod-img" />
                <div className="hover-overlay">
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                  <Link to={item.link} className="prod-link">
                    Explore Products <span>↗</span>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </section>
  );
}

export default Products;
